export const DUPLICATE_CALL_MESSAGE = 'Similar request already in progress';

export const validateError = (error, func) => {
    if (error !== DUPLICATE_CALL_MESSAGE) {
        func(error);
    }
    //skip
};